import { render, staticRenderFns } from "./ArquivoAnalise.vue?vue&type=template&id=140f1ac6&scoped=true"
import script from "./ArquivoAnalise.vue?vue&type=script&lang=js"
export * from "./ArquivoAnalise.vue?vue&type=script&lang=js"
import style0 from "./ArquivoAnalise.vue?vue&type=style&index=0&id=140f1ac6&prod&lang=css"
import style1 from "./ArquivoAnalise.vue?vue&type=style&index=1&id=140f1ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f1ac6",
  null
  
)

export default component.exports